module.exports = __webpack_public_path__ + "img/open_primary.b4552bf5.png";